/**
 * Bildirishnomalar API. Backenddan ma'lumot oladi.
 * API snake_case qaytaradi, frontend camelCase kutadi.
 */
import api from './api';
import { endpoints } from './endpoints';

function ensureList(res) {
  if (res?.data != null && Array.isArray(res.data)) return res.data;
  if (Array.isArray(res)) return res;
  return [];
}

function normalizeItem(raw) {
  if (!raw || typeof raw !== 'object') return null;
  const metaRaw = raw.meta ?? '';
  const meta =
    typeof metaRaw === 'string'
      ? metaRaw
      : metaRaw && typeof metaRaw === 'object'
        ? Object.entries(metaRaw)
            .filter(([, v]) => v != null && String(v).trim() !== '')
            .map(([k, v]) => `${k}: ${String(v)}`)
            .join(' · ')
        : '';
  return {
    id: String(raw.id ?? raw),
    type: raw.type ?? 'system',
    priority: raw.priority ?? 'normal',
    titleKey: raw.title_key ?? raw.titleKey ?? 'adminNotif_system_title',
    bodyKey: raw.body_key ?? raw.bodyKey ?? 'adminNotif_system_body',
    title: raw.title ?? null,
    body: raw.body ?? null,
    timestamp: raw.timestamp ?? '',
    read: Boolean(raw.read),
    linkPath: raw.link_path ?? raw.linkPath ?? null,
    meta,
  };
}

export async function getNotifications(params = {}) {
  const res = await api.get(endpoints.notifications, { params });
  const list = ensureList(res);
  return list.map(normalizeItem).filter(Boolean);
}

export async function markNotificationRead(id) {
  if (id == null || id === '') return { id: String(id ?? ''), read: true };
  const res = await api.patch(endpoints.notificationRead(id));
  return res?.data?.data ?? { id: String(id), read: true };
}

export async function markAllNotificationsRead() {
  await api.patch(endpoints.notificationsReadAll);
}
